import React, { FunctionComponent } from 'react'
import styled from 'styled-components'

interface AlphaTagProps {
  className?: string
}

const AlphaTag: FunctionComponent<AlphaTagProps> = ({ className }) => (
  <Alpha className={className}>ALPHA</Alpha>
)

export default AlphaTag

export const Alpha = styled.div`
  width: fit-content;
  padding: 0px 8px;
  background: ${({ theme }): string => theme.colors.tagStatus.warningBg};
  border-radius: 10px;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  color: ${({ theme }): string => theme.colors.tagStatus.warning};
`
